
// Get all div with classname "board-card-wrapper"
var boardCards = document.querySelectorAll('.board-card-wrapper');

// Give unique classnames to style them
boardCards.forEach(function (card, index) {
    if (index % 2 === 0) {
        card.classList.add('board-card-image-left');
    } else {
        card.classList.add('board-card-image-right');
    }
});
